/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2014-2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
*/

(function () {
  angular.module('bulbApp.authorModule')
    .controller('AuthorController', ['authorUnit', 'authorAccount', 'resume', '$location', '$rootScope', '$scope', '$state', '$stateParams', '$timeout', '$window', 'Restangular', 'AeroDialogService', 'AnalyticsService', 'BulbAuthService', 'BulbBrowserService', 'BulbDeletedUnitService', 'BulbModalService', 'FamilyMemberService', 'FeatureFlagService', 'ResumeService', 'TourService', 'AUTH', 'AUTHOR_TABS', 'CONFIG', AuthorController]);

  function AuthorController(
    authorUnit,
    authorAccount,
    resume,
    $location,
    $rootScope,
    $scope,
    $state,
    $stateParams,
    $timeout,
    $window,
    Restangular,
    AeroDialogService,
    AnalyticsService,
    BulbAuthService,
    BulbBrowserService,
    BulbDeletedUnitService,
    BulbModalService,
    FamilyMemberService,
    FeatureFlagService,
    ResumeService,
    TourService,
    AUTH,
    AUTHOR_TABS,
    CONFIG,
  ) {
    const that = this;

    this.compositeUnit = authorUnit;
    this.authorAccount = authorAccount.plain();
    this.authorAccount.circularImage = this.compositeUnit.circularImage;

    this.isUsersOwnProfile = (BulbAuthService.currentUser.id === this.authorAccount.id);
    $rootScope.protofolioUserId = this.compositeUnit.id;

    // --------------------------------------------------------------------------------------------------
    // Set up the profile tabs
    // --------------------------------------------------------------------------------------------------

    this.showBadges = $state.is('badges');
    this.showResume = false;
    this.showPortfolio = false;
    this.showFamily = false;
    this.showRecentlyDeleted = false;
    this.showTabControl = false;
    this.showRecentlyDeletedView = false;
    this.deletedUnitCount = 0;
    BulbDeletedUnitService.getDeletedUnitCount().then((deletedUnitCount) => {
      if (deletedUnitCount !== 0) {
        this.deletedUnitCount = (deletedUnitCount);
        this.showRecentlyDeleted = true;
        numShown++;
        this.showTabControl = true;
      }
    });

    let numShown = 0;

    // Don't render tabs if viewing badges
    if (!this.showBadges) {
    // Determine if we should show the resume to the user or not
      if ((resume !== null && BulbAuthService.currentUser.hasPermission(resume, AUTH.PERMISSIONS.READ))
      || (resume === null && this.isUsersOwnProfile
        && BulbAuthService.currentUser.features.ResumeFeature.resumeEnabled)) {
        this.showResume = true;
        numShown++;

        // Flag to load the resume component the first time the resume tab is selected
        this.resumeReadyToLoad = false;
      }

      // Determine if we should show the portfolio to the user or not
      if (BulbAuthService.currentUser.hasPermission(authorUnit, AUTH.PERMISSIONS.READ)) {
        this.showPortfolio = true;
        numShown++;
      }

      // Determine if we should show the family feed to the user or not
      if (this.isUsersOwnProfile && BulbAuthService.currentUser.hasRole(AUTH.ROLES.FAMILY_MEMBER)) {
        this.showFamily = true;
        numShown++;
        initFamilyFeed();
      }

      // Based on the number of sections shown, show the tab control
      if (numShown > 1) {
        this.showTabControl = true;

        this.activeTab = {};

        $timeout(() => {
          that.selectTab($stateParams.authorTab);
        });
      }
    }

    // --------------------------------------------------------------------------------------------------
    // Setting up family activity feed
    // --------------------------------------------------------------------------------------------------

    /**
   * Boolean to display orange notification icon on the Student tab of family accounts:
   * @type {boolean}
   */
    this.newFamilyActivitiesExist = false;

    /**
   * Function to initialize the family activity feed
   */
    function initFamilyFeed() {
    // Initial fetch of family activities
      FamilyMemberService.fetchStudentActivities(that.authorAccount.id).then((response) => {
        that.allActivities = response;
        if (that.allActivities.length !== 0) {
          FamilyMemberService.setNewActivitiesToTrue(that.allActivities);
          that.newFamilyActivitiesExist = FamilyMemberService.newActivitiesExist;
        }
      });

      // Listener to update the tab orange icon if the parent clicks the new event
      $window.addEventListener('setNewFamilyAccountActivity', (data) => {
        if (data.detail.setNewActivity) {
        // Update the activities:
          data.detail.activities.forEach((activity) => {
            if (!activity.isNew) {
              that.newFamilyActivitiesExist = false;
            }
          });
        }
      });
    }

    /**
   * Capture how many times the Student Activity tab is 'used' i.e clicked.
   */
    function familyAnalyticsEvent() {
      const studentActivityTabEventObject = {
        event: 'FamilyAccountStudentActivityTab',
        userId: BulbAuthService.currentUser.id,
      };
      AnalyticsService.pushEvent(studentActivityTabEventObject);
    }

    // --------------------------------------------------------------------------------------------------
    // Handle any welcome dialogs
    // --------------------------------------------------------------------------------------------------

    this.showWelcome = ($stateParams.welcome && this.isUsersOwnProfile);
    this.showTrial = ($stateParams.trial && this.isUsersOwnProfile);
    this.showCodeUsed = ($stateParams.prepaidCode && this.isUsersOwnProfile);

    const { codes } = BulbAuthService.currentUser.features.ActivatedCodesFeature;
    this.teacherActivatedCode = (codes.length > 0 && BulbAuthService.currentUser.position === 'EDUCATOR');
    this.ableToCreateMacMillanGroups = BulbAuthService.isAbleToMakeMacMillanGroups(codes);

    // Show Welcome dialog if appropriate:
    if (BulbAuthService.currentUser.prefs.onBoarding.onboardingShowMainTour) {
      if (this.teacherActivatedCode && this.ableToCreateMacMillanGroups) {
        showMacMillanDialog();
      } else {
        showStartingTemplatesDialog();
      }
    }

    function showMacMillanDialog() {
      const ref = AeroDialogService.showMacMillanBookDialog(true, false);
      ref.onClose.subscribe(() => {
        showStartingTemplatesDialog();
      });
    }

    function showStartingTemplatesDialog() {
      // Only show the getting started templates if the user has only logged in once before, is on their own profile,
      // and hasn't seen it before.
      if (BulbAuthService.currentUser.prefs.onBoarding.onboardingShowStartingTemplates
        && that.compositeUnit.unitType === 'UserUnit'
        && that.isUsersOwnProfile
        && !CONFIG.base.url.startsWith('https://eu.')
      ) {
        const ref = AeroDialogService.showGettingStartedTemplateDialog(BulbAuthService.currentUser.position, true);
        if (TourService.isTourActive()) {
           TourService.hideTour();
        }
        // Wrapped in try as sometimes the ref isn't fully instantiated yet for some reason.
        try {
          ref.onClose.subscribe(() => {
            $state.reload();
          });
        } catch (_) { }
      } else {
        showWelcomeDialog();
      }
    }

    function showWelcomeDialog() {
      if (that.compositeUnit.unitType === 'UserUnit'
        && that.isUsersOwnProfile) {
        $timeout(() => {
          TourService.startMainTour();
        }, 0);
      }
    }

    // --------------------------------------------------------------------------------------------------
    // Handle tab changes
    // --------------------------------------------------------------------------------------------------

    /**
   * On tab selection, set the resume tab is selected true or false.
   */
    this.selectTab = function (selectedTab) {
    // Update resume service and load the resume component when the resume tab is selected
      if (selectedTab === AUTHOR_TABS.RESUME) {
        ResumeService.isResumeTabSelected = true;

        // We keep the resume loaded once it has been loaded, so we never set this back to false.
        that.resumeReadyToLoad = true;
      } else {
        ResumeService.isResumeTabSelected = false;
      }

      // Fire an analytics event if the family tab is selected
      if (selectedTab === AUTHOR_TABS.FAMILY) {
        familyAnalyticsEvent();
      }

      // Update the address bar and browser history
      updateUrl(selectedTab);

      // Set the new active tab
      that.activeTab[selectedTab] = true;
    };

    this.toggleShowDeleted = function () {
      BulbDeletedUnitService.isRecentlyDeletedSelected = true;
    }

    /**
   * Method for updating the address bar url as different tabs are selected.
   * @param selectedTabPath
   */
    function updateUrl(selectedTabPath) {
    // All we need to do is update the address bar, so this will update it without having to reload the state.
    // and don't update it it is already correct
      const updatedPath = `/${that.authorAccount.username}/${selectedTabPath}`;
      if (updatedPath !== $location.path()) {
        $location.skipReload().path(updatedPath);
      }
    }

    /**
   * Location change listener for handling back button.
   *
   * NOTE: we are doing this because of an issue with Angular handling the back button that sometimes doesn't fire
   * correctly, so this is a workaround to ensure that we update the selected tab to match the URL in the address bar.
   */
    $scope.$on('$locationChangeSuccess', (event) => {
      const urlSegment = $location.path().split('/').pop();
      // Only update the tab if tab control is visible and urlSegment is valid AUTHOR_TABS.
      if (that.showTabControl && Object.values(AUTHOR_TABS).includes(urlSegment)) {
        that.selectTab(urlSegment);
      }
    });

    // Watcher to hide the all the tabsets when recently deleted is clicked.
    $scope.$watch(() => BulbDeletedUnitService.isRecentlyDeletedSelected, (value) => {
      if (numShown > 1) {
        that.showRecentlyDeletedView = value;
        if (value) {
          that.showTabControl = false;
        } else {
          that.showTabControl = true;
          $state.go('author');
        }
      } else {
        that.showRecentlyDeletedView = value;
        if (!value && BulbDeletedUnitService.navigateToAuthor) {
          $state.go('author');
        }
      }
    });

    // we are doing this for updating Page units after restoration of pages.
    $scope.$on('updatePageUnitDTO', (event, updatedUnit) => {
      this.compositeUnit = updatedUnit;
    });
  }
}());
